@if(!isLoading) {
<div>
    <div class="ot-row">
        <div class="otsc-prop-header">
            <h1 class="otsc-prop-header-text" i18n>Proxy</h1>
            <div class="ot-btn-group otsc-prop-header-btn">
                <button id="otsc-settings-proxy-save-btn" role="button" class="ot-btn ot-btn--is-primary"
                    (click)="save()" [disabled]="!settingsForm.dirty || settingsForm.invalid">
                    {{savingBtn}}
                </button>
                <button id="otsc-settings-proxy-reset-btn" role="button" class="ot-btn ot-btn--is-secondary"
                    (click)="reset()" [disabled]="!settingsForm.dirty" i18n>
                    Reset
                </button>
            </div>
        </div>
    </div>
    @if(isProxyModeCtrl.value && authTypeCtrl.value == 'ntlm') {
    <div class="ot-message ot-message--is-error">
        <div class="ot-message__banner">
            <p class="ot-pl-1" id="otsc-settings-proxy-ntlm-deprecated-msg" i18n>
                NTLM authentication is no longer supported. Please select a different authentication type.
            </p>
        </div>
    </div>
    }
    <form [formGroup]="settingsForm" name="otsc-settings-proxy-form">
        <div style="height: calc(100vh - 165px);">
            <ng-scrollbar #scrollbarRef>
                <div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-2">
                    <div id="otsc-settings-proxy">
                        <app-checkbox [identifier]="'isProxyMode'" formControlName="isProxyModeCtrl"
                            [name]="'isProxyMode'" [toggle]="true" i18n-label [label]="'Use a proxy server'"
                            i18n-arialabel [arialabel]="'Enable/disable proxy server'" i18n-description
                            [description]="'Use a proxy server if you do not have direct connection to the Internet'"
                            (ngModelChange)="setFormControlsEnabled()">
                        </app-checkbox>
                    </div>
                    <div class="ot-row">
                        <div class="ot-col ot-row__column ot-row__column--is-33">
                            <div class="ot-form-control"
                                [ngClass]="{'ot-form-control--is-invalid' : isProxyModeCtrl.value && serverUrlCtrl.invalid}">
                                <label class="ot-form-control__label" for="serverUrl" i18n
                                    [required]="isProxyModeCtrl.value"
                                    [ngClass]="{'ot-form-control__required-indicator': isProxyModeCtrl.value}">
                                    Server
                                </label>
                                <div class="ot-form-control__input-group">
                                    <input id="serverUrl" formControlName="serverUrlCtrl"
                                        placeholder="Enter proxy server URL" type="text" maxlength="50"
                                        class="ot-input ot-input--is-expanded" [readonly]="!this.isProxyModeCtrl.value">
                                </div>
                                @if(isProxyModeCtrl.value && serverUrlCtrl.invalid) {
                                <p id="serverURLRequiredMsg" class="ot-form-control__error-text" i18n
                                    autocomplete="off">
                                    Server URL is required.
                                </p>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="ot-row">
                        <div class="ot-col ot-row__column ot-row__column--is-33">
                            <div class="ot-form-control"
                                [ngClass]="{'ot-form-control--is-invalid' : isProxyModeCtrl.value && portCtrl.invalid}">
                                <label class="ot-form-control__label" for="port" i18n>
                                    Port
                                </label>
                                <div class="ot-form-control__input-group">
                                    <input id="port" formControlName="portCtrl" placeholder="Enter proxy server port"
                                        type="number" maxlength="6" class="ot-input ot-input--is-expanded"
                                        [readonly]="!this.isProxyModeCtrl.value">
                                </div>
                                @if(portCtrl.invalid) {
                                <p id="invalidServerPortMsg" class="ot-form-control__error-text" i18n
                                    autocomplete="off">
                                    Server port is invalid.
                                </p>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="ot-row">
                        <div class="ot-col ot-row__column ot-row__column--is-33">
                            <div class="ot-form-control"
                                [ngClass]="{'ot-form-control--is-invalid' : isProxyModeCtrl.value && authTypeCtrl.invalid}">
                                <label class="ot-form-control__label" for="authType" i18n
                                    [ngClass]="{'ot-form-control__required-indicator': isProxyModeCtrl.value}">
                                    Authentication type
                                </label>
                                <div class="ot-select" style="padding-bottom: 0px;">
                                    <select id="authType" name="authType" formControlName="authTypeCtrl"
                                        aria-label="Select authentication type" (change)="setFormControlsEnabled()">
                                        <option value="none" i18n>None</option>
                                        <option value="digest" i18n>Basic/Digest</option>
                                        @if(this.settings.authType == 'ntlm'){
                                        <option value="ntlm" i18n>NTLM</option>
                                        }
                                    </select>
                                </div>
                                @if(isProxyModeCtrl.value && authTypeCtrl.invalid && authTypeCtrl.value == 'ntlm') {
                                <p id="auth-type-error-msg" class="ot-form-control__error-text" i18n autocomplete="off"
                                    style="margin-top: 0px;" i18n>
                                    NTLM is no longer supported. Please select a different authentication type.
                                </p>
                                } @else {
                                <p id="auth-type-info-msg" class="ot-form-control__error-text" i18n autocomplete="off"
                                    style="margin-top: 0px;" i18n>
                                    Authentication type is required.
                                </p>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="ot-row">
                        <div class="ot-col ot-row__column ot-row__column--is-33">
                            <app-checkbox [identifier]="'storeCredentials'" formControlName="storeCredentialsCtrl"
                                [name]="'storeCredentials'" i18n-label [label]="'Store credentials'" i18n-arialabel
                                [arialabel]="'Store credentials for proxy server'" i18n-description
                                [description]="'Storing credentials is required for automatic updating of the manifest. Otherwise users will be prompted for their proxy credentials on each product or patch download and manifest update.'">
                            </app-checkbox>
                        </div>
                    </div>
                    <div class="ot-row">
                        <div class="ot-col ot-row__column ot-row__column--is-33">
                            <div class="ot-form-control"
                                [ngClass]="{'ot-form-control--is-invalid' : storeCredentialsCtrl.value && usernameCtrl.invalid}">
                                <label class="ot-form-control__label" for="username" i18n
                                    [ngClass]="{'ot-form-control__required-indicator': isProxyModeCtrl.value && storeCredentialsCtrl.value}">
                                    User name
                                </label>
                                <div class="ot-form-control__input-group">
                                    <input id="username" formControlName="usernameCtrl"
                                        placeholder="Enter proxy server user name" type="text" maxlength="50"
                                        class="ot-input ot-input--is-expanded"
                                        [readonly]="!isProxyModeCtrl.value || authTypeCtrl.value == 'none' || !storeCredentialsCtrl.value"
                                        [required]="isProxyModeCtrl.value && storeCredentialsCtrl.value">
                                </div>
                                @if(storeCredentialsCtrl.value && usernameCtrl.invalid) {
                                <p id="invalidUsernameMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                                    Username is required.
                                </p>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="ot-row">
                        <div class="ot-col ot-row__column ot-row__column--is-33">
                            <div class="ot-form-control"
                                [ngClass]="{'ot-form-control--is-invalid' : storeCredentialsCtrl.value && settingsForm.dirty && passwordCtrl.invalid}">
                                <label class="ot-form-control__label" for="password" i18n
                                    [ngClass]="{'ot-form-control__required-indicator': isProxyModeCtrl.value && storeCredentialsCtrl.value}">
                                    Password
                                </label>
                                <div class="ot-form-control__input-group ot-form-control--is-horizontal">
                                    <input id="password" formControlName="passwordCtrl"
                                        placeholder="Enter proxy server password"
                                        [type]="this.showPwd ? 'text' : 'password'" maxlength="50"
                                        class="ot-input ot-input--is-expanded"
                                        [readonly]="!isProxyModeCtrl.value || authTypeCtrl.value == 'none' || !storeCredentialsCtrl.value">
                                    @if(storeCredentialsCtrl.value) {
                                    <button id="showPasswordBtn" title="Show password" i18n-title
                                        style="height: 32px;width: 32px;" class="ot-btn ot-icon ot-icon--is-action-icon"
                                        [ngClass]="{'otsc-icon-sprite-show': !showPwd, 'otsc-icon-sprite-hide':showPwd}"
                                        (click)="this.showPwd = !this.showPwd">
                                    </button>
                                    }
                                </div>
                                @if(passwordCtrl.invalid) {
                                <p id="invalidPasswordMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                                    Password is required.
                                </p>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="ot-row">
                        <div class="otsc-settings-label otsc-settings-label-desc" i18n>
                            Exceptions
                        </div>
                    </div>
                    <div class="ot-row">
                        <div class="ot-col ot-row__column ot-row__column--is-33">
                            <div class="ot-form-control ot-mb-0">
                                <label class="ot-form-control__label" for="exceptionURL" i18n>
                                    Do not use proxy for servers beginning with:
                                </label>
                                <div class="ot-form-control ot-form-control--is-horizontal">
                                    <input id="exceptionURL" formControlName="exceptionURLCtrl"
                                        placeholder="Enter proxy server name to exclude" type="text" maxlength="50"
                                        class="ot-input ot-input--is-expanded" [readonly]="!isProxyModeCtrl.value">
                                    <button id="addExceptionURLBtn" style="height: 32px;width: 32px;"
                                        class="ot-btn ot-icon ot-icon--is-action-icon otsc-icon-sprite-add"
                                        (click)="addToExceptions()" title="Add" i18n-title
                                        [disabled]="!isProxyModeCtrl.value">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ot-row">
                        <div class="ot-col ot-row__column ot-row__column--is-33">
                            <div class="ot-chips" id="exceptionURLChips">
                                @for(url of exceptionURLList; track $index) {
                                <div class="ot-chip" [ngClass]="{'ot-chip--is-disabled': !isProxyModeCtrl.value}">
                                    {{url}}
                                    @if(isProxyModeCtrl.value) {
                                    <button [attr.otdata]="url" class="ot-chip__close"
                                        (click)="exceptionURLList.splice(i, 1)">
                                    </button>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </ng-scrollbar>
        </div>
    </form>
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
        <div class="ot-progress__meter">
        </div>
    </div>
    <div class="ot-progress__text" id="otsc-settings-proxy-loading" i18n>Loading...</div>
</div>
}